import React from 'react'

interface Props {
  width: string
  height: string
  fill: string
}

const IconViber = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg width={width} height={height} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'>
      <path
        fill={fill}
        opacity={0.3}
        d='M64.2 6a57.92 57.92 0 0 0-49.35 88.37L5.8 122l33.64-5.61A58 58 0 1 0 64.2 6Z'
      />
      <path
        fill={fill}
        d='M29.1 44.58A55.37 55.37 0 0 0 84.37 100h1.81A13.86 13.86 0 0 0 99 83.47a13.58 13.58 0 0 0-.8-2.63L75 77.14a13.74 13.74 0 0 0-3.19 7.06 41.63 41.63 0 0 1-26.58-26 13.78 13.78 0 0 0 6.83-3.2l-3.65-23.12a12.75 12.75 0 0 0-3.2-1 13.27 13.27 0 0 0-2.29-.2 13.84 13.84 0 0 0-13.82 13.9Z'
      />
    </svg>
  )
}

export default IconViber
